/*
 * BB discount keeper (2026-10-26)
 * A code from a /discount/CODE link lives in the discount_code cookie, but on a fresh
 * cart it often never lands on the cart itself, so the side cart shows full price
 * until checkout re-applies it. After any cart write (theme, Monk, Candyrack), if the
 * cookie code is missing from the cart, re-apply it the same way the theme's own
 * coupon box does (fetch /discount/CODE) and re-render the drawer.
 */
(function () {
  if (window.__bbDiscountKeeper) return;
  window.__bbDiscountKeeper = true;

  var nativeFetch = window.fetch.bind(window);
  var CART_WRITE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var attempts = 0;
  var MAX_ATTEMPTS = 3;
  var timer = null;
  var busy = false;

  function getCode() {
    var m = document.cookie.match(/(?:^|;\s*)discount_code=([^;]*)/);
    if (!m) return '';
    try { return decodeURIComponent(m[1]).trim(); } catch (e) { return m[1].trim(); }
  }

  function refreshDrawer(cart) {
    if (window.sharedFunctions && window.sharedFunctions.updateSidebarCart) {
      window.sharedFunctions.updateSidebarCart(cart);
    }
    if (document.body.classList.contains('template-cart')) {
      var key = 'bbDiscountKeeperReload';
      if (!sessionStorage.getItem(key)) {
        sessionStorage.setItem(key, '1');
        window.location.reload();
      }
    }
  }

  function ensureCode() {
    if (busy || attempts >= MAX_ATTEMPTS) return;
    var code = getCode();
    if (!code) return;
    busy = true;
    nativeFetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart.item_count) return;
        var has = (cart.discount_codes || []).some(function (d) {
          return d.code && d.code.toLowerCase() === code.toLowerCase();
        });
        if (has) return;
        attempts += 1;
        return nativeFetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' })
          .then(function () { return nativeFetch('/cart.js', { credentials: 'same-origin' }); })
          .then(function (r) { return r.json(); })
          .then(refreshDrawer);
      })
      .catch(function () {})
      .then(function () { busy = false; });
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(ensureCode, 700);
  }

  window.fetch = function (input, init) {
    var url = (input && input.url) || String(input);
    var p = nativeFetch(input, init);
    if (CART_WRITE.test(url)) p.then(schedule, function () {});
    return p;
  };

  var open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (CART_WRITE.test(String(url))) this.addEventListener('load', schedule);
    return open.apply(this, arguments);
  };

  document.addEventListener('submit', function (e) {
    if (e.target && CART_WRITE.test(e.target.getAttribute('action') || '')) schedule();
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }
})();
